import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../common/types';
import { checklistMessages as messages } from './checklistMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the checklist; each part uses its own slice of it */
import styles from './FirstReleaseChecklist.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChecklistDoneProps {
  songTitle: string | null;
  /** "Hide" on Home. Without it and without `onShow` the line has no button (a member). */
  onHide?: () => void;
  /** "Show the checklist again" in Settings -> Setup after a dismiss (design d6). */
  onShow?: () => void;
}

/** Every shown item is done: the card folds to one line (design: onboarding d4). */
const ChecklistDoneComponent: React.FC<ChecklistDoneProps> = ({ songTitle, onHide, onShow }) => {
  const intl = useIntl();
  return (
    <div className={styles.done} data-testid="checklist-done">
      <span className={styles.doneIcon}>
        <FontAwesomeIcon icon={faCheck} />
      </span>
      <span className={styles.doneText}>
        {songTitle === null
          ? intl.formatMessage(messages.doneNoSong)
          : intl.formatMessage(messages.done, { song: songTitle })}
      </span>
      {onShow !== undefined ? (
        <button type="button" className={styles.linkButton} onClick={onShow}>
          {intl.formatMessage(messages.setupShow)}
        </button>
      ) : null}
      {onShow === undefined && onHide !== undefined ? (
        <button type="button" className={styles.linkButton} onClick={onHide}>
          {intl.formatMessage(messages.hide)}
        </button>
      ) : null}
    </div>
  );
};

export const ChecklistDone = TypedMemo(ChecklistDoneComponent);
